module.exports = __webpack_public_path__ + "assets/img/4d65-dj.svg";